import b from "@emotion/styled/base";
import { Button as n } from "@partoohub/ui";
function c() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const e = /* @__PURE__ */ b(n, process.env.NODE_ENV === "production" ? {
  target: "emu10b20"
} : {
  target: "emu10b20",
  label: "StyledButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1a3vc7o",
  styles: "padding:0 8px 0 16px"
} : {
  name: "1a3vc7o",
  styles: "padding:0 8px 0 16px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvbW9kdWxhci1jb21wb25lbnRzL3NyYy9jb21wb25lbnRzL0J1c2luZXNzTW9kYWwvc3ViQ29tcG9uZW50cy9CdXNpbmVzc01vZGFsQnV0dG9uL0R5bmFtaWNCdXNpbmVzc01vZGFsQnV0dG9uL3ZhcmlhbnQvUGFnZUJ1dHRvbi9QYWdlQnV0dG9uLnN0eWxlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHMEMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvcGFydG9vLXVpL3BhcnRvby11aS9wYWNrYWdlcy9tb2R1bGFyLWNvbXBvbmVudHMvc3JjL2NvbXBvbmVudHMvQnVzaW5lc3NNb2RhbC9zdWJDb21wb25lbnRzL0J1c2luZXNzTW9kYWxCdXR0b24vRHluYW1pY0J1c2luZXNzTW9kYWxCdXR0b24vdmFyaWFudC9QYWdlQnV0dG9uL1BhZ2VCdXR0b24uc3R5bGVkLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQnV0dG9uIH0gZnJvbSAnQHBhcnRvb2h1Yi91aSc7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b24gPSBzdHlsZWQoQnV0dG9uKWBcbiAgICBwYWRkaW5nOiAwIDhweCAwIDE2cHg7XG5gO1xuIl19 */",
  toString: c
});
export {
  e as StyledButton
};
